import React from "react";
import PropTypes from "prop-types";

const SelectInput2 = ({
  icon,
  name,
  value,
  label,
  onChange,
  isLabeled,
  placeholder,
  ...props
}) => {
  return (
    <div className="app-search p-0 mb-2" {...props}>
      <div className="input-group">
        <select
          data-tip
          name={name}
          value={value}
          htmlFor={name}
          data-for={name}
          onChange={onChange}
          data-toggle="select2"
          data-live-search="true"
          className="form-control"
          style={{ backgroundColor: "#d9e6f2" }}
        >
          {isLabeled ? <option value="">{label}</option> : null}
          {props.children}
        </select>

        <span className={icon}></span>
      </div>
    </div>
  );
};

SelectInput2.propTypes = {
  children: PropTypes.any,
  name: PropTypes.string.isRequired,
  icon: PropTypes.string,
  value: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isLabeled: PropTypes.bool.isRequired,
  placeholder: PropTypes.string.isRequired
};

export default SelectInput2;
